import Axios from 'axios'
import { setupCache } from 'axios-cache-interceptor'

import { attachKalpInterceptors } from './interceptors'

/**
 * The single `global.axios` instance.
 *
 * This used to be constructed twice — once at module scope in VerticalMenu.jsx
 * and again in views/main/index.jsx — so whichever module happened to evaluate
 * last won, and the 224 call sites across the app could be talking to either one.
 * Building it once here makes the instance deterministic and gives every existing
 * call site the shared session handling without any of them being edited.
 *
 * Deliberately NO blanket timeout. The service runs with `Server.timeout = 0`
 * because billing operations legitimately take minutes; cutting those off midway
 * would be worse than letting them run. Interactive endpoints should set their
 * own timeout per call instead — see ClientHeader, which uses 15s for a typeahead.
 */
const instance = Axios.create()

const globalAxios = attachKalpInterceptors(setupCache(instance), { label: 'global.axios' })

if (typeof globalThis !== 'undefined') {
  globalThis.axios = globalAxios
}

export default globalAxios
